<template>
    <FormSection
        :full-height="false"
        title="Company Security Setup"
        :application-id="'1'"
        :show-background="true"
        :use-gray-theme="true"
    >
        <template #content>
            <section class="p-5 d-flex flex-column text-center text-primary" v-if="isLoading">
                <i class="fa fa-spinner fa-spin font-size-5xl me-2 animated slow flash infinite"></i>
                <span class="mt-1 big-text">
                    <b>Loading...</b>
                </span>
            </section>
            <section v-else>
                <div class="container row m-0 py-2">
                    <div class="col-12">
                        <h6 class="mb-2 d-flex align-items-center">
                            <b class="me-2">Verify Signature</b>
                        </h6>
                        <p>
                            Before proceeding, enter your signature for given organization in the textbox provided below
                            to confirm that you are authorized to make changes to your company information.
                        </p>
                    </div>
                    <div class="col-5 ps-2 pe-2">
                        <div class="pb-1 mb-2"><strong>Organization Name</strong></div>
                        <div class="pb-1 mb-2"><strong>Signature</strong> <span class="text-danger">*</span></div>
                    </div>
                    <div class="col-7 ps-4 pe-4">
                        <div class="pb-1 mb-2">
                            {{ organizationName }}
                        </div>
                        <input
                            class="form-control"
                            maxlength="50"
                            name="organization-name"
                            type="password"
                            placeholder="Enter Signature"
                            v-model="signature"
                            :class="`${!v$.signature.$error ? '' : 'field-invalid'}`"
                            @blur="v$.signature.$touch"
                        />
                        <span v-if="v$.signature.$error" class="field-invalid"
                            >Please provide your signature before proceeding.</span
                        >
                    </div>
                </div>
                <div class="d-flex justify-content-center mb-3 mt-2" v-if="!isLoading">
                    <span v-if="isVerifying">
                        <button class="btn btn-primary">
                            <i class="fa fa-spinner fa-spin animated slow flash infinite"></i>
                        </button>
                    </span>
                    <span v-else>
                        <button type="button" class="btn btn-md btn-outline-secondary" @click="cancel()">Cancel</button>
                        <button class="btn btn-primary ms-2" @click="verifySignature()">Proceed</button>
                    </span>
                </div>
            </section>
        </template>
    </FormSection>
</template>

<script lang="ts" src="./SignatureVerification.ts"></script>
